import cryptojs from 'crypto-js'
import store from 'store'
import orderBy from 'lodash/orderBy'
import getEnv from 'utils/getEnv'

const isTest = getEnv() === 'test'

const APP_KEY = isTest ? 'APP_TEST' : 'WEB_APISIGN' // 与web侧约定的key
const APP_SECRET = isTest ? 'test123' : 'QUWmBAYddriiHcKu'

// 对请求体进行排序
function sortRequestBody(body) {
  if (body.includes('&')) {
    return orderBy(
      body
        .split('&')
        .map(item => item.split('='))
        .filter(d => d[1]),
      '0'
    )
      .map(d => d[0] + '=' + d[1])
      .join('&')
  }
  return body
}

// 对请求体进行签名
function cryptoRequestBody(request) {
  if (request.method === 'GET') return ''
  const contentType = request.headers.get('Content-Type') || ''
  const body = request.body || ''
  if (body) {
    // 做个排序
    if (contentType.startsWith('application/x-www-form-urlencoded')) {
      return sortRequestBody(body)
    } else {
      return cryptojs.MD5(body).toString()
    }
  }
  return body
}

// 签名拦截器
export default function apiSignature(request, next) {
  const urlObj = new URL(request.url)
  if (request.hostType !== 'oauth') return next()
  const timestamp =
    new Date().getTime() - store.state.timegap.localServerTimeGap
  const signHeaders = Object.entries({
    'x-ca-timestamp': timestamp,
    'x-ca-key': APP_KEY,
    'x-ca-nonce': cryptojs.MD5(`${timestamp}-${Math.random()}`).toString()
  })

  signHeaders.forEach(([header, value]) => {
    request.headers.set(header, String(value))
  })

  const querySeg = Object.keys(request.params)
    .filter(key => request.params[key] !== undefined)
    .sort()
    .map(key => `${key}=${request.params[key]}`)
    .join('&')
  const data = cryptoRequestBody(request)
  const headerSeg = signHeaders
    .sort()
    .map(it => `${it[0]}:${it[1]}`)
    .join('\n')
  const content = [
    request.method,
    urlObj.pathname,
    querySeg,
    data,
    headerSeg
  ].join('\n')
  const sign = cryptojs.enc.Base64.stringify(
    cryptojs.HmacSHA256(content, APP_SECRET)
  )
  request.headers.set('x-ca-signature', sign)
  return next()
}
